import type { Booking } from "../types/booking";
import { COMMODITY_INSPECTION } from "../lib/pricingDefaults";

/** True when commodity inspection is required on this booking. */
export const getEffectiveCommodityInspection = (
  booking: Pick<Booking, "commodity_inspection">
): boolean => booking.commodity_inspection === true;

export const COMMODITY_INSPECTION_FEE_EUR = COMMODITY_INSPECTION.BASE_FEE;
